// extracted by mini-css-extract-plugin
export var audioPlayer = "_ng-0";